<template>
  <div class="h-layout h100-60">
    <div class="h-left" v-if="left_.show">
      <div class="h-title">{{left_.name}}
        <div class="h-icon-close-left"><span class="icon hero-icon hero-icon-tile"></span></div>
      </div>
      <slot name="left_view"></slot>
    </div>
    <div class="h-left2" v-if="middle_.show">
      <div class="h-title">{{middle_.name}}
        <div class="h-icon-close-left"><span class="icon hero-icon hero-icon-tile"></span></div>
      </div>
      <slot name="middle_view"></slot>
    </div>
    <div class="h-right" v-if="right_.show">
      <div class="h-crumbs">{{right_.crumb}}</div>
      <slot name="right_view"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicLayout',
  props: ['left', 'middle', 'right'],
  data() {
    return {
      left_: this.left,
      middle_: this.middle,
      right_: this.right,
    };
  }
};
</script>
